import { get, post, put, del } from "../client";
import {
  GET_MESSAGE_TEMPLATES,
  CREATE_MESSAGE_TEMPLATE,
  UPDATE_MESSAGE_TEMPLATE,
  DELETE_MESSAGE_TEMPLATE,
  TOGGLE_MESSAGE_TEMPLATE,
} from "../routes";

const MESSAGE_TEMPLATES = {
  getAll: async () => await get(GET_MESSAGE_TEMPLATES),
  create: async (data) => await post(CREATE_MESSAGE_TEMPLATE, data),
  update: async (id, data) => await put(UPDATE_MESSAGE_TEMPLATE(id), data),
  remove: async (id) => await del(DELETE_MESSAGE_TEMPLATE(id)),
  toggle: async (id) => await put(TOGGLE_MESSAGE_TEMPLATE(id), {}),
};

export default MESSAGE_TEMPLATES;
